import Rx from 'ub_wrapped/rx';

const loginModalSubject = new Rx.Subject();

const notifySessionExpire = (statusCode) => {
  const UNAUTHORIZED_ERROR = 401;
  if (statusCode === UNAUTHORIZED_ERROR) {
    loginModalSubject.onNext({type: 'unauthorized'});
  }
};

export default {
  loginModalSubject,
  notifySessionExpire
};



// WEBPACK FOOTER //
// ./src/ui/login/state-controller.js